<div class="custom-action-column">
    <smart-icon (click)="onDeleteClick()" name="trash" class="light" [style.visibility]="deletable? 'visible':'hidden'">
    </smart-icon>
</div>